import { SkeletonLoader } from '@lab39/react-ui';
import styles from './HomePageSkeleton.module.css';

const HomePageSkeleton = () => {
  return (
    <div className={styles.home}>
      <div className={styles.container}>
        <div className={styles.layout}>
          <aside className={styles.sidebar}>
            <SkeletonLoader variant="rectangular" width="100%" height="40px" />
            <SkeletonLoader variant="rectangular" width="100%" height="40px" />
            <SkeletonLoader variant="rectangular" width="100%" height="40px" />
            <SkeletonLoader variant="rectangular" width="100%" height="40px" />
            <SkeletonLoader variant="rectangular" width="100%" height="40px" />
            <SkeletonLoader variant="rectangular" width="100%" height="50px" />
          </aside>

          <div className={styles.editorSection}>
            <div className={styles.controlGroup}>
              <SkeletonLoader variant="text" width="60px" height="20px" />
              <SkeletonLoader variant="rectangular" width="100%" height="200px" />
            </div>
            
            <div className={styles.controlGroup}>
              <SkeletonLoader variant="text" width="80px" height="20px" />
              <SkeletonLoader variant="rectangular" width="100%" height="450px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageSkeleton;
